<template>
  <vip-user></vip-user>
</template>

<script>
import VipUser from "../../../newVip/order/discountsVerification";
export default {
  data() {
    return {};
  },
  components: {
    VipUser
  }
};
</script>
